import { createFeatureSelector } from '@ngrx/store';
import { deferralFeatureKey } from '../reducers';
import { DeferralState } from '../reducers/deferral.reducer';

export const selectDeferralState =
  createFeatureSelector<DeferralState>(deferralFeatureKey);
